import _extends from "@babel/runtime-corejs3/helpers/extends";

var _POSITION_MAP;

import React from 'react';
import classnames from 'classnames';
import { createComponent, PropTypes } from "../../../wayin-react";
import { whitelistStyles } from "../hoc";
import { positions, colors, sizes } from "../../../enums";
/* INTERFACE */

var propTypes = {
  tooltip: PropTypes.string,
  children: PropTypes.node.isRequired,
  isInline: PropTypes.bool,
  isCompact: PropTypes.bool,
  position: PropTypes.oneOf(positions.ALL),
  color: PropTypes.oneOf([colors.BASE, colors.ERROR]),
  isMultiLine: PropTypes.bool,
  isDisabled: PropTypes.bool,
  width: PropTypes.oneOf(sizes.S_M_L)
};
var defaultProps = {
  tooltip: null,
  isInline: true,
  position: positions.TOP,
  color: colors.BASE,
  isCompact: false,
  isMultiLine: false,
  isDisabled: false,
  width: sizes.S
};
var contextTypes = {
  isInverted: PropTypes.bool
};
var state = {
  isVisible: {
    value: false,
    updater: function updater(setIsVisible) {
      return {
        show: function show() {
          setIsVisible(true);
        },
        hide: function hide() {
          setIsVisible(false);
        }
      };
    }
  }
};
/* RENDER */

function render(props) {
  var _classnames;

  var className = classnames((_classnames = {
    ck: true,
    tooltip: true,
    inline: props.isInline,
    inverted: props.isInverted
  }, _classnames["tooltip--width-" + props.width] = true, _classnames['tooltip--hidden'] = !props.isVisible, _classnames['tooltip--compact'] = props.isCompact, _classnames['tooltip--multiline'] = props.isMultiLine, _classnames.disabled = props.isDisabled, _classnames), props.color);
  var ttProps = {
    className: className,
    style: props.style
  };

  if (props.tooltip) {
    ttProps['data-ck-tooltip'] = props.tooltip;
    ttProps['data-ck-position'] = POSITION_MAP[props.position] || props.position;
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, ttProps, {
    onMouseOver: props.show,
    onMouseDown: props.hide,
    onKeyDown: props.hide,
    onMouseOut: props.hide,
    onFocus: props.hide
  }), props.children);
}
/* BLUEPRINT */


var Tooltip = createComponent({
  displayName: 'Tooltip',
  propTypes: propTypes,
  defaultProps: defaultProps,
  contextTypes: contextTypes,
  state: state,
  render: render
});
/* PRIVATE HELPERS */

var POSITION_MAP = (_POSITION_MAP = {}, _POSITION_MAP[positions.TOP] = 'top center', _POSITION_MAP[positions.BOTTOM] = 'bottom center', _POSITION_MAP[positions.LEFT] = 'left center', _POSITION_MAP[positions.RIGHT] = 'right center', _POSITION_MAP);
export default whitelistStyles()(Tooltip);
//# sourceMappingURL=tooltip.js.map